/** Client-generated staff Link A Ask Cleo session id (close/idle digest key). */
export function newLinkAAskSessionId(): string {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch {
    /* ignore */
  }
  return `linka-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
